import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: "detail",
  class: "changelog-popup__details"
}
const _hoisted_2 = { key: "list" }

import { computed, ref } from 'vue'
import type { ChangelogView } from '@/models/changelog'
import BasePopup from '@/components/ui/BasePopup.vue'
import Item from './Item.vue'
import { backend } from '@/services/backend'
import type { Changelog } from '@/models/interfaces'
import * as Mixpanel from '@/analytics/mixpanel/mixpanel'

export default /*@__PURE__*/_defineComponent({
  __name: 'Popup',
  props: {
    view: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

// Note: in vue 3.5 we need to switch to useTemplateRef
const popup = ref<InstanceType<typeof BasePopup> | null>(null)

const selectedId = ref<string | null>(null)
const lastScrollPosition = ref<number>(0)
const containerRef = ref<HTMLElement | null>(null)

async function selectItem(item: Changelog): Promise<void> {
  // Store scroll position before any transition
  if (containerRef.value) {
    lastScrollPosition.value = containerRef.value.scrollTop
  }

  selectedId.value = item.id

  Mixpanel.trackChangelogItemClick(item)

  // If the item is historical or already read, we don't need to mark it as read
  if (item.is_historical || item.is_read) {
    return
  }

  await backend.markReadChangelog(item.id)

  // Update the item in the view
  item.is_read = true
  props.view.refreshIfNeeded(true)
}

const selectedItem = computed(() => {
  return props.view.data.find((item) => item.id === selectedId.value)
})

function show(): void {
  popup.value?.show()
}

function hide(): void {
  popup.value?.hide()
}

function goBack(): void {
  selectedId.value = null
}

// Handle transition end to restore scroll position
function onTransitionEnd(): void {
  if (containerRef.value) {
    // If we're in list view (selectedId is null), restore scroll position
    // Otherwise (in detail view), scroll to top
    containerRef.value.scrollTo({
      top: selectedId.value === null ? lastScrollPosition.value : 0,
    })
  }
}

__expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasePopup, {
    ref_key: "popup",
    ref: popup,
    title: "What's new and features",
    class: "changelog-popup",
    fullscreen: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "containerRef",
        ref: containerRef,
        class: "changelog-popup__container"
      }, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in",
          onEnter: onTransitionEnd
        }, {
          default: _withCtx(() => [
            (selectedItem.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(Item, {
                    item: selectedItem.value,
                    isDetail: true,
                    onBack: goBack
                  }, null, 8, ["item"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.view.data, (item) => {
                    return (_openBlock(), _createBlock(Item, {
                      key: item.id,
                      item: item,
                      onClick: ($event: any) => (selectItem(item))
                    }, null, 8, ["item", "onClick"]))
                  }), 128))
                ]))
          ]),
          _: 1
        })
      ], 512)
    ]),
    _: 1
  }, 512))
}
}

})